import { Badge } from '@/components/ui/badge';

interface StatusBadgeProps {
  status: string;
}

const statusVariantMap: Record<string, 'success' | 'danger' | 'warning' | 'secondary' | 'info'> = {
  active: 'success',
  online: 'success',
  completed: 'success',
  inactive: 'secondary',
  offline: 'danger',
  failed: 'danger',
  pending: 'warning',
  cancelled: 'secondary',
  expired: 'secondary',
  maintenance: 'warning',
  refunded: 'info',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const variant = statusVariantMap[status] || 'secondary';
  return <Badge variant={variant}>{status}</Badge>;
}
